// Default page size
export const BLOG_ARTICLES_PER_PAGE = 10

// Format a date from the CMS
export const formatBlogDate = (str) =>
  new Intl.DateTimeFormat("en-US", { month: "long", year: "numeric", day: "numeric" }).format(new Date(str))
